<template>
  <v-container class="page">
    <h3 style="text-align: center; margin-top: 20px; margin-bottom: 15px;">
      UMOWA UDZIAŁU W IMPREZIE TURYSTYCZNEJ NR {{ nrUmowy }} Z DNIA
      {{
        new Date()
          .toJSON()
          .slice(0, 10)
          .replace(/(\d+)-(\d+)-(\d+)/, "$3-$2-$1")
      }}
    </h3>
    <table id="table_container">
      <tbody>
        <tr>
          <td style="border: 1px solid;">
            <p class="cell-in-first-table">
              <span><strong>Organizator</strong></span>
            </p>
            <p class="cell-in-first-table" style="fontStyle: italic;">
              <span>Tutore Poland Sp. z o.o.</span>
            </p>
            <p class="cell-in-first-table">
              <span>ul. Piotrkowska 157A, 90-440 Łódź</span>
            </p>
            <p class="cell-in-first-table">
              <span>NIP 727 281 2193</span>
            </p>
            <p class="cell-in-first-table">
              <span>KRS 0000670834</span>
            </p>
            <p class="cell-in-first-table">
              <span
                >Kapitał Zakładowy: 1 664 600,00 zł, w całości opłacony</span
              >
            </p>
          </td>
        </tr>

        <tr>
          <td style="border: 1px solid;">
            <p
              class="cell-in-first-table"
              style="margin-top: 5px; margin-bottom: 5px;"
            >
              <strong> Miejsce i czas trwania:</strong> {{ turnus.slice(3) }}
            </p>
          </td>
        </tr>

        <tr>
          <td style="border: 1px solid;">
            <p
              class="cell-in-first-table"
              style="margin-top: 5px; margin-bottom: 5px;"
            >
              <strong> Nazwa obozu lub imprezy:</strong> {{ nazwaObozu() }}
            </p>
          </td>
        </tr>

        <tr>
          <td style="border: 1px solid;">
            <div class="cell-in-first-table">
              <strong>Dane zgłaszającego:</strong>
              <p style="margin-top: 7px;">
                Imię i nazwisko: {{ imieNazwiskoOpiekuna }}
                <span style="margin-left: 200px;">tel: {{ tel }}</span>
              </p>
              <p style="margin-top: 2px;">
                e-mail: {{ email }}
              </p>
            </div>
          </td>
        </tr>

        <tr>
          <td style="border: 1px solid;">
            <div class="cell-in-first-table">
              <strong>Dane uczestnika/uczestników:</strong
              ><span style="font-size: 11px;">
                (imię i nazwisko, data urodzenia, adres zamieszkania):</span
              >
              <p style="margin-top: 5px;">
                1. {{ imieDziecka }} {{ nazwiskoDziecka }},
                {{ dataUrodzeniaDziecka }}, {{ adres }}
              </p>
            </div>
          </td>
        </tr>

        <tr>
          <td style="border: 1px solid;">
            <div class="cell-in-first-table">
              <strong>Zakupione świadczenia:</strong>
              <ol>
                <li>
                  Obóz: {{ nazwaObozu() }}: {{ turnus.slice(3) }} (
                  {{ showCenaObozu() }}
                  zł)
                </li>
                <li>Dojazd: {{ dojazd }}</li>
                <li>Powrót: {{ powrot }}</li>
                <li>Opcje dodatkowe:</li>
                <ul>
                  <li v-if="pendrive !== 'Nie (0 zł)'">
                    Pendrive: {{ pendrive }}
                  </li>
                  <li v-if="dieta !== 'Brak (0 zł)'">{{ dieta }}</li>
                  <li v-if="pakietSafety !== 'Brak (0 zł)'">
                    Pakiet Safety: {{ pakietSafety }}
                  </li>
                  <li v-if="spiewnik">
                    Śpiewnik: {{ spiewnik }}
                  </li>
                  <li v-if="odznakaJezdziecka !== 'Nie (0 zł)'">
                    Odznaka jeździecka "Jeżdżę konno": {{ odznakaJezdziecka }}
                  </li>
                </ul>
                <li>
                  Rabaty i zniżki: {{ rabatUzasadnienie }} (-{{ rabat }} zł)
                </li>
              </ol>
            </div>
          </td>
        </tr>

        <tr>
          <td style="border: 1px solid;">
              <p class="cell-in-first-table">
              <strong>Płatności:</strong>
              </p>
              <p class="cell-in-first-table">Cena całkowita: {{ cenaCalkowita }} zł</p>
              <p class="cell-in-first-table">
                Zaliczka płatna do {{ terminZaliczka === "30-12-1899" ? "... " : terminZaliczka }}: {{ countZaliczka() }} zł
              </p>
              <p class="cell-in-first-table">
                Pozostała część kwoty płatna do {{ terminResztaKwota === "30-12-1899" ? "... " : terminResztaKwota }}:
                {{ pozostalaKwota }} zł
              </p>
          </td>
        </tr>

        <tr>
          <td style="border: 1px solid;">
            <p class="cell-in-first-table">
              <span><strong>Dane do przelewu (Organizatora)</strong></span>
            </p>
            <p class="cell-in-first-table" style="fontStyle: italic;">
              <span>Tutore Poland Sp. z o.o.</span>
            </p>
            <p class="cell-in-first-table">
              <span>ul. Piotrkowska 157A, 90-440 Łódź</span>
            </p>
            <p class="cell-in-first-table">
              <span>nr konta: 76 1090 2590 0000 0001 3433 5287</span>
            </p>
          </td>
        </tr>

        <tr>
          <td style="border: 1px solid;">
            <div class="cell-in-first-table">
              <p>
                Oświadczam za siebie i za innych uczestników imprezy turystycznej, w imieniu których dokonuje płatności za imprezę turystyczną, że przed zawarciem umowy uczestnictwa w imprezie turystycznej otrzymałem /am Ogólne Warunki Ubezpieczenia Wyjazdów Turystycznych „Ubezpieczeni w podróży” zatwierdzone uchwałą Zarządu Wiener TU S.A. nr 131/21 z dnia 07.10.2021 r. wraz z informacją o produkcie ubezpieczenia „w podróży” Wiener TU S.A , stanowiące załącznik do niniejszej umowy.
              <br>
                Ja niżej podpisany/a zapoznałem się z ceną, programem, zakresem usług oraz Warunkami Uczestnictwa, w których określone są zasady dotyczące bezpieczeństwa oraz przechowywania danych osobowych, zgłaszam udział w imprezie wyżej wymienionych osób i zobowiązuję się do uregulowania należności w terminach opisanych w Warunkach Uczestnictwa.
              </p>
              <div class="flex-container" style="margin-bottom: 25px;">
                <div class="aside flex-item">
                  ------------------------------------
                </div>
                <div class="aside flex-item">
                  -----------------------------------------
                </div>
                <div class="flex-item">Miejscowość i data</div>
                <div class="flex-item">Podpis klienta</div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </v-container>
</template>

<script>
export default {
  name: "UmowaKolonie2023",
  props: {},
  data() {
    return {
      turnus: "",
      oboz: "",
      imieDziecka: "",
      nazwiskoDziecka: "",
      dataUrodzeniaDziecka: "",
      nrUmowy: "",
      tel: "",
      imieNazwiskoOpiekuna: "",
      adres: "",
      cenaCalkowita: "",
      dojazd: "",
      powrot: "",
      pendrive: "",
      dieta: "",
      pakietSafety: "",
      rabat: "",
      rabatUzasadnienie: "",
      spiewnik: "",
      terminZaliczka: "",
      terminResztaKwota: "",
      kwotaOboz: "",
      zgodaWizerunek: "",
      email: "",
      odznakaJezdziecka: "",
      pozostalaKwota: "",
    };
  },
  created() {
    Object.entries(this.$route.query).forEach(([key, value]) => {
      this[key] = value;
    });
  },
  methods: {
    showCenaObozu() {
      switch(this.oboz) {
        case '15. Klub jeździecki Music':
            return '3099'
            break;
        case '26. Konny':
            return '2999'
            break;
        case '27. Windsurfingowy':
            return '3099'
            break;
        default:
            return '2599'
      }
    },
    nazwaObozu() {
      const array = this.oboz.split('.');
      if(this.oboz === '15. Klub jeździecki Music') {
        return '15. Klub jeździecki Music&More'
      } else if(this.oboz === '19. Make up' || this.oboz === '19. Make up ') {
        return '19. Make up & SPA'
      } else if(array[0].length === 2){
        return this.oboz.slice(3)
      } else {
        return this.oboz.slice(2)
      }
    },
    countZaliczka() {
      let pakiet = 0;
      switch (this.pakietSafety) {
        case "Brak (0 zł)":
          pakiet = 0;
          break;
        case "Safety Basic (99 zł)":
          pakiet = 99;
          break;
        case "Safety Premium (159 zł)":
          pakiet = 159;
          break;
        case "Safety Platinum (249 zł)":
          pakiet = 249;
          break;
      }
      const finalZaliczka = 600 + pakiet;
      return finalZaliczka;
    },
  },
  mounted() {
    if (this.turnus) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href;
          history.replaceState(history.state, "", "/");
          window.print();
          history.replaceState(history.state, "", currentURL);
        }, 300);
      });
    }
  },
};
</script>

<style scoped>
#table_container {
border: 1px solid;
text-align: left;
margin: auto;
width: 100%;
}
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 0px;
  padding-top: 0px;
}
table, th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 5px;
}
#signature_space {
  font-size: 14px;
  float: right;
  margin-right: 10px;
  margin-top: 27px;
}
#signature {
    font-size: 14px;
    float: right;
    margin-top: 50px;
    margin-right: -246px;
    margin-bottom: 15px;
}
.flex-container {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: wrap;
}
.flex-item {
    width: 300px;
    height: 20px;
    text-align: center;
    margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaKolonie2023.vue